/* ============================================================================
   noctaura-interact.js - Maison Noctaura, SITE_BUILD_2026-10-27.md (built 2026-10-28)
   The interactive commerce the leading jewellery stores run, in our own motion language:
     1. mega menu      - Gifts / Shop panels open on hover-intent, click, touch or keyboard (rank 3)
     2. card crossfade - a curated second photo is fetched on the FIRST pointer hover only (rank 4)
     3. recently viewed- the PDP rail from this browser's own history, live prices (rank 5)
     4. rail dedupe    - "Complete the gift" never repeats a piece already shown above it (rank 5)
   No library. Deferred, so nothing here can hold first paint. Reduced motion: CSS turns the motion off;
   this file only toggles state.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- 1 · MEGA MENU ---------- */
  var OPEN_DELAY = 120, CLOSE_DELAY = 220;
  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-nx-mm]'));
  var current = null, openTimer = 0, closeTimer = 0;

  function panelFor(name) { return document.querySelector('[data-nx-mm-panel="' + name + '"]'); }
  function setExpanded(name, on) {
    triggers.forEach(function (t) { if (t.getAttribute('data-nx-mm') === name) t.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function open(name) {
    clearTimeout(closeTimer);
    if (current === name) return;
    if (current) close(true);
    var p = panelFor(name);
    if (!p) return;
    p.hidden = false;
    // next frame so the fade + hairline draw run from their start state
    requestAnimationFrame(function () { requestAnimationFrame(function () { p.classList.add('is-open'); }); });
    setExpanded(name, true);
    current = name;
  }
  function close(now) {
    clearTimeout(openTimer);
    if (!current) return;
    var name = current, p = panelFor(name);
    current = null;
    setExpanded(name, false);
    if (!p) return;
    p.classList.remove('is-open');
    if (now) { p.hidden = true; return; }
    setTimeout(function () { if (current !== name) p.hidden = true; }, 260);
  }
  function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { close(false); }, CLOSE_DELAY); }

  triggers.forEach(function (t) {
    var name = t.getAttribute('data-nx-mm');
    t.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      clearTimeout(closeTimer); clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(name); }, current ? 0 : OPEN_DELAY);
    });
    t.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') { clearTimeout(openTimer); scheduleClose(); } });
    // touch (tablets at desktop width): first tap opens the panel, a second tap follows the link
    t.addEventListener('click', function (e) {
      if (current !== name && t.__nxTouch) { e.preventDefault(); open(name); }
      t.__nxTouch = false;
    });
    t.addEventListener('pointerdown', function (e) { t.__nxTouch = e.pointerType === 'touch'; });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || ((e.key === ' ' || e.key === 'Spacebar') && current !== name)) {
        e.preventDefault(); open(name);
        var first = panelFor(name) && panelFor(name).querySelector('a');
        if (first) setTimeout(function () { first.focus(); }, 30);
      }
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-nx-mm-panel]'), function (p) {
    p.addEventListener('pointerenter', function () { clearTimeout(closeTimer); });
    p.addEventListener('pointerleave', scheduleClose);
    p.addEventListener('focusout', function (e) {
      if (!p.contains(e.relatedTarget) && !(e.relatedTarget && e.relatedTarget.hasAttribute && e.relatedTarget.hasAttribute('data-nx-mm'))) scheduleClose();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !current) return;
    var name = current; close(true);
    var t = document.querySelector('[data-nx-mm="' + name + '"]'); if (t) t.focus();
  });
  document.addEventListener('pointerdown', function (e) {
    if (current && !e.target.closest('[data-nx-mm-panel],[data-nx-mm]')) close(false);
  }, { passive: true });

  /* ---------- 2 · CARD CROSSFADE: load photo 2 on the first real hover, never on a phone ---------- */
  var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (fine) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.card-gallery');
      if (!card) return;
      var img = card.querySelector('.nx-hover__img[data-src]');
      if (!img) return;
      img.addEventListener('load', function () { img.classList.add('is-ready'); }, { once: true });
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    }, { passive: true });
  }

  /* ---------- 3 · RECENTLY VIEWED (PDP only) ---------- */
  var KEY = 'nx_viewed_v1', MAX = 8;
  var rv = document.querySelector('[data-nx-rv]');
  function readList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function writeList(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) { /* private mode */ } }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  if (rv) {
    var here = rv.getAttribute('data-handle');
    var list = readList().filter(function (h) { return h && h !== here; });
    writeList([here].concat(list));
    var want = list.slice(0, 4);
    var grid = rv.querySelector('[data-nx-rv-grid]');
    var build = function () {
      Promise.all(want.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        items = items.filter(function (p) { return p && p.available !== false; });
        if (items.length < 2 || !grid) return;
        grid.innerHTML = items.map(function (p) {
          var img = p.featured_image ? '<img src="' + esc(sized(p.featured_image, 420)) + '" srcset="' + esc(sized(p.featured_image, 300)) + ' 300w, ' + esc(sized(p.featured_image, 420)) + ' 420w" sizes="(min-width:750px) 22vw, 60vw" alt="" loading="lazy" width="420" height="525">' : '';
          return '<a class="nxs-more__card" href="' + esc(p.url) + '"><span class="nxs-more__fig">' + img + '</span>' +
                 '<span class="nxs-more__name">' + esc(p.title) + '</span><span class="nxs-more__price">' + esc(money(p.price)) + '</span></a>';
        }).join('');
        rv.hidden = false;
      });
    };
    if (want.length >= 2) {
      if ('requestIdleCallback' in window) requestIdleCallback(build, { timeout: 2500 }); else setTimeout(build, 1200);
    }
  }

  /* ---------- 4 · "Complete the gift" never repeats a piece shown in "More from <collection>" ---------- */
  var recs = document.querySelector('product-recommendations');
  if (recs) {
    var seen = function () {
      var s = {};
      Array.prototype.forEach.call(document.querySelectorAll('.nxs-more__card[href]'), function (a) { s[a.pathname] = 1; });
      s[location.pathname] = 1;
      return s;
    };
    var dedupe = function () {
      var s = seen();
      Array.prototype.forEach.call(recs.querySelectorAll('.resource-list__item, .resource-list__slide, slideshow-slide'), function (item) {
        var a = item.querySelector('a[href*="/products/"]');
        if (!a) return;
        var path = a.pathname.replace(/^\/collections\/[^/]+/, '');
        if (s[path]) item.setAttribute('data-nx-dupe', '');
      });
    };
    new MutationObserver(dedupe).observe(recs, { childList: true, subtree: true });
    dedupe();
  }

  /* ---------- 5 · THE DESK waits off the home hero (Desk v2, 2026-10-28) ----------
     The launcher arrives once the eclipse hero has scrolled away; the CSS lives in
     snippets/noctaura-concierge.liquid ([data-hero="1"]). */
  var desk = document.getElementById('nxd-root');
  var hero = document.getElementById('hero');
  if (desk && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { desk.setAttribute('data-hero', e.isIntersecting && e.intersectionRatio > 0.35 ? '1' : '0'); });
    }, { threshold: [0, 0.35, 0.6] }).observe(hero);
  }
})();
